var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29463 12.72C8.15394 12.5795 8.07481 12.3888 8.07463 12.19V11.81C8.07693 11.6116 8.15575 11.4217 8.29463 11.28L13.4346 6.14997C13.5285 6.05532 13.6563 6.00208 13.7896 6.00208C13.9229 6.00208 14.0507 6.05532 14.1446 6.14997L14.8546 6.85997C14.9487 6.95214 15.0017 7.07828 15.0017 7.20997C15.0017 7.34166 14.9487 7.46781 14.8546 7.55997L10.4046 12L14.8546 16.44C14.9493 16.5339 15.0025 16.6617 15.0025 16.795C15.0025 16.9283 14.9493 17.0561 14.8546 17.15L14.1446 17.85C14.0507 17.9446 13.9229 17.9979 13.7896 17.9979C13.6563 17.9979 13.5285 17.9446 13.4346 17.85L8.29463 12.72Z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.f8aecafaa31c2117db23585b154866a5.svg";
export { ForwardRef as ReactComponent };